var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 18.1094H14.5V17.6094V15.6406V15.1406H14H11.9844V8.64062V8.14062H11.4844H7.875H7.375V8.64062V10.6094V11.1094H7.875H9.01562V15.1406H7H6.5V15.6406V17.6094V18.1094H7H14ZM1.75 0.5H19.25C19.5815 0.5 19.8995 0.631696 20.1339 0.866116C20.3683 1.10054 20.5 1.41848 20.5 1.75V19.25C20.5 19.5815 20.3683 19.8995 20.1339 20.1339C19.8995 20.3683 19.5815 20.5 19.25 20.5H1.75C1.41848 20.5 1.10054 20.3683 0.866116 20.1339C0.631696 19.8995 0.5 19.5815 0.5 19.25V1.75C0.5 1.41848 0.631696 1.10054 0.866116 0.866116C1.10054 0.631696 1.41848 0.5 1.75 0.5ZM11.507 3.30546C11.2089 3.1063 10.8585 3 10.5 3C10.0193 3 9.55828 3.19096 9.21837 3.53087C8.87846 3.87078 8.6875 4.33179 8.6875 4.8125C8.6875 5.17098 8.7938 5.52141 8.99296 5.81947C9.19212 6.11753 9.47519 6.34985 9.80639 6.48703C10.1376 6.62422 10.502 6.66011 10.8536 6.59017C11.2052 6.52024 11.5281 6.34761 11.7816 6.09413C12.0351 5.84065 12.2077 5.51769 12.2777 5.1661C12.3476 4.81451 12.3117 4.45008 12.1745 4.11889C12.0373 3.7877 11.805 3.50462 11.507 3.30546Z",
    fill: "#E3F1D9",
    stroke: "#74B743"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs);
export default __webpack_public_path__ + "static/media/aboutUs.dbc0c9c90ab067ebd11bbe604895d6fe.svg";
export { ForwardRef as ReactComponent };